export const TOGGLE_CATEGORY_NODE = 'categories/TOGGLE_CATEGORY_NODE';
export const SHOW_ADD = 'categories/SHOW_ADD';
export const HIDE_ADD = 'categories/HIDE_ADD';
